import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'tenant-name-modal',
  templateUrl: './tenant-name-modal.component.html',
  styleUrls: ['./tenant-name-modal.component.scss'],
  standalone: false,
})
export class TenantNameModalComponent {
  tenantName: string;

  constructor(
    public dialogRef: MatDialogRef<TenantNameModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.tenantName = data.tenantName;
  }

  confirm() {
    this.dialogRef.close(this.tenantName);
  }

  dismiss() {
    this.dialogRef.close(false);
  }
}
